// extracted by mini-css-extract-plugin
export default {"button":"MenuButton_button__W731T","active":"MenuButton_active__u7Xdw"};